import React from "react"
import { Navigate } from "react-router-dom"
import { Routes } from "@/core/routing/routes"
import { useAuth } from "@/hooks/useAuth"
import Loader from "../Loader"

type Props = {
  children: React.ReactNode
}

const RequireAuth = ({ children }: Props) => {
  const { user, isLoading, token } = useAuth()

  if (isLoading) {
    return (
      <div className="h-screen w-screen flex justify-center items-center">
        <Loader />
      </div>
    )
  }

  if (!token || user === null) {
    return <Navigate to={Routes.login} replace />
  }
  return children
}

export default RequireAuth
